export const STATUS = {
  UNINITIALIZED: 'edrolo/attachments/UNINITIALIZED',
  LOADING: 'edrolo/attachments/LOADING',
  RELOADING: 'edrolo/attachments/RELOADING',
  READY: 'edrolo/attachments/READY',
  FAILURE: 'edrolo/attachments/FAILURE',
};

export { FAILURE_REASON } from 'edrolo/domains/net';

export const ATTACHMENT_TYPE = {
  LESSON: 'lessons',
  EXAM: 'exams',
  BRANCH: 'branches',
};

// ms, and will increase exponentially on each failure, e.g. 100 =  200ms, 400ms, 800ms, 1600
export const NETWORK_BACKOFF_INTERVAL = 200;
export const NETWORK_RETRY_COUNT = 5;

// ms, timeout after triggering for watermarking of PDF files
export const WATERMARK_TIMEOUT = 120000;
export const WATERMARK_POLLING_INTERVAL = 5000;
